import React from 'react';

import { TOpsProgramDetailEx } from '../../../requests/opsRegistrationsExtra';
import { Card, labelClass, Pill } from '../ui';
import { money, signed } from './shared';

/** Invested, used and remaining — and, on a Team Pass, value consumed. */
const AccountingCard: React.FC<{
  program: TOpsProgramDetailEx;
  live: boolean;
}> = ({ program, live }) => (
  <Card title="Accounting Data">
    <div className="grid grid-cols-2 gap-x-6 gap-y-4 px-5 py-4">
      <div>
        <div className={labelClass}>Original program amount</div>
        <div className="text-sm text-gray-five [font-variant-numeric:tabular-nums]">
          {money(program.invested)}
        </div>
      </div>
      <div>
        <div className={labelClass}>Funds used</div>
        <div className="text-sm text-gray-five [font-variant-numeric:tabular-nums]">
          {money(program.used)}
        </div>
        {live && (
          <div className="mt-0.5 text-xs text-gray-bold [font-variant-numeric:tabular-nums]">
            Salesforce {money(program.usedSalesforce)} · portal{' '}
            {signed(program.usedPortal)}
          </div>
        )}
      </div>
      {program.teamPass ? (
        <>
          <div>
            <div className={labelClass}>Value consumed</div>
            <div className="text-xl font-bold text-gray-four [font-variant-numeric:tabular-nums]">
              {money((program.usedSalesforce ?? 0) + program.valueConsumed)}
            </div>
            <div className="mt-0.5 text-xs text-gray-bold">
              Team Pass — seats and events are tallied, the balance is not drawn
              down.
              {live &&
                ` Tallied by the portal: ${money(program.valueConsumed)}.`}
            </div>
          </div>
          <div>
            <div className={labelClass}>Remaining balance</div>
            <div className="text-sm text-gray-five [font-variant-numeric:tabular-nums]">
              {money(program.remaining)}
            </div>
          </div>
        </>
      ) : (
        <div>
          <div className={labelClass}>Remaining balance</div>
          <div className="text-xl font-bold text-gray-four [font-variant-numeric:tabular-nums]">
            {money(program.remaining)}
          </div>
        </div>
      )}
      {!live && program.pendingDryRun > 0 && (
        <div>
          <div className={labelClass}>Rehearsed, not applied</div>
          <div className="text-sm text-gray-five [font-variant-numeric:tabular-nums]">
            {money(program.pendingDryRun)}
          </div>
        </div>
      )}
      {program.renewed && (
        <div>
          <div className={labelClass}>Renewal</div>
          <Pill value="renewed" tone="good" />
        </div>
      )}
    </div>
  </Card>
);

export default AccountingCard;
